export default "__VITE_ASSET__CSep7$Pb__"